import Vue from 'vue'
import Router from 'vue-router'
import RouteView from '@/components/shared/RouteView'
// import axios from 'axios'
import Dashboard from '@/views/Dashboard'
import Login from '@/views/login/Login'
import LoginForm from '@/components/login/LoginForm'
import LoginPasswordForm from '@/components/login/LoginPasswordForm'
import EnvironmentDashboard from '@/views/EnvironmentDashboard'
import ParksAndGardensDashboard from '@/views/ParksAndGardensDashboard'
// import ParksAndGardensMain from '@/views/ParksAndGardensMain'
// import PredictiveModels from '@/views/PredictiveModels'
import VisualizationDashboard from '@/views/VisualizationDashboard'
// import PredictiveModelsDashboard from '@/views/PredictiveModelsDashboard'
import PredictiveModelsList from '@/views/predictiveModels/PredictiveModelsList'
import PredictiveModelsPollution from '@/views/predictiveModels/PredictiveModelsPollution'
import PredictiveModelsSports from '@/views/predictiveModels/PredictiveModelsSports'
import MobilityAndTransportMain from '@/views/MobilityAndTransportMain'
// import AutobusesDashboard from '@/views/AutobusesDashboard'
// import BikeDashboard from '@/views/BikeDashboard'
// import ParkingDashboard from '@/views/ParkingDashboard'
import CruisesMain from '@/views/CruisesMain'
// import CruisesHistoricDashboard from '@/views/CruisesHistoricDashboard'
// import CruisesRealTimeDashboard from '@/views/CruisesRealTimeDashboard'
import CRMDashboard from '@/views/CRMDashboard'
// import CRMMain from '@/views/CRMMain'

import Profile from '@/views/Profile'
// import store from '@/store/store.js'

Vue.use(Router)

const route = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      redirect: { name: 'login-form' },
      children: [
        {
          path: '',
          name: 'login-form',
          component: LoginForm
        },
        {
          path: 'password',
          name: 'password-form',
          component: LoginPasswordForm
        }
      ]
    },
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        private: true,
        breadcrumbTextKey: 'dashboard'
      }
    },
    {
      path: '/PredictiveModels',
      name: 'PredictiveModelsDashboard',
      component: RouteView,
      redirect: { name: 'PredictiveModels' },
      meta: {
        private: true,
        breadcrumbTextKey: 'predictiveModels'
      },
      children: [
        {
          path: '',
          name: 'PredictiveModels',
          component: PredictiveModelsList
        },
        {
          path: 'PredictiveModelsPollution',
          name: 'PredictiveModelsPollution',
          component: PredictiveModelsPollution,
          meta: {
            private: true,
            breadcrumbTextKey: 'contaminaciónenelaire'
          }
        },
        {
          path: 'PredictiveModelsSports',
          name: 'PredictiveModelsSports',
          component: PredictiveModelsSports,
          meta: {
            private: true,
            breadcrumbTextKey: 'instalacionesdeportivas'
          }
        }
      ]
    },
    {
      path: '/ParksAndGardens',
      name: 'ParksAndGardensDashboard',
      component: ParksAndGardensDashboard,
      meta: {
        private: true,
        breadcrumbTextKey: 'parksAndGardens'
      },
      children: [
        {
          path: 'ParksAndGardensCompare',
          name: 'ParksAndGardensDashboardCompare',
          component: ParksAndGardensDashboard,
          meta: {
            private: true,
            breadcrumbTextKey: 'mapCompare'
          }
        }
      ]
    },
    {
      path: '/environment-and-meteorology-dashboard',
      name: 'EnvironmentDashboard',
      component: EnvironmentDashboard,
      meta: {
        private: true,
        breadcrumbTextKey: 'environment'
      }
    },
    {
      path: '/MobilityAndTransport',
      name: 'MobilityAndTransportMain',
      component: MobilityAndTransportMain,
      // redirect: { name: 'ParkingDashboard' },
      meta: {
        private: true,
        breadcrumbTextKey: 'mobility'
      }
      /*
      children: [
        {
          path: 'AutobusesDashboard',
          name: 'AutobusesDashboard',
          component: AutobusesDashboard,
          meta: {
            private: true,
            breadcrumbTextKey: 'autobuses'
          }
        },
        {
          path: 'BikeDashboard',
          name: 'BikeDashboard',
          component: BikeDashboard,
          meta: {
            private: true,
            breadcrumbTextKey: 'bike'
          }
        },
        {
          path: 'ParkingDashboard',
          name: 'ParkingDashboard',
          component: ParkingDashboard,
          meta: {
            private: true,
            breadcrumbTextKey: 'parking'
          }
        }
      ]
      */
    },
    {
      path: '/VisualizationDashboard',
      name: 'VisualizationDashboard',
      component: VisualizationDashboard,
      meta: {
        private: true,
        breadcrumbTextKey: 'visualization'
      }
    },
    {
      path: '/Cruises',
      name: 'CruisesMain',
      component: CruisesMain,
      // redirect: { name: 'CruisesRealTimeDashboard' },
      meta: {
        private: true,
        breadcrumbTextKey: 'cruises'
      }
      // children: [
      //   {
      //     path: 'CruisesRealTimeDashboard',
      //     name: 'CruisesRealTimeDashboard',
      //     component: CruisesRealTimeDashboard,
      //     meta: {
      //       private: true,
      //       breadcrumbTextKey: 'cruisesRealTime'
      //     }
      //   },
      //   {
      //     path: 'CruisesHistoricDashboard',
      //     name: 'CruisesHistoricDashboard',
      //     component: CruisesHistoricDashboard,
      //     meta: {
      //       private: true,
      //       breadcrumbTextKey: 'cruisesHistoric'
      //     }
      //   }
      // ]
    },
    {
      path: '/CRM',
      name: 'CRMDashboard',
      component: CRMDashboard,
      meta: {
        private: true,
        breadcrumbTextKey: 'crm'
      }
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: {
        private: true,
        breadcrumbTextKey: 'profile'
      }
    },
    {
      path: '*', redirect: '/login'
    }
  ]
})

// -- Descomentar cuando no se quiera tener mockeado el login
// route.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.private)) {
//     if (!sessionStorage.getItem('sessionToken')) {
//       next({name: 'Login'})
//     } else {
//       axios.defaults.headers.common['Authorization'] = `Bearer ${sessionStorage.getItem('sessionToken')}`
//       next()
//     }
//   } else {
//     next()
//   }
// })

export default route



// WEBPACK FOOTER //
// ./src/router/index.js